import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'clsx';
import { twMerge } from 'tailwind-merge';
import ExclamationCircleIcon from '../../Icons/solid/ExclamationCircleIcon';
export const InputTextArea = React.forwardRef((t0, ref) => {
  const $ = _c(60);
  let className;
  let cornerAdornment;
  let description;
  let disabled;
  let error;
  let fullWidth;
  let id;
  let label;
  let name;
  let onBlur;
  let onChange;
  let placeholder;
  let props;
  let required;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      cornerAdornment,
      description,
      disabled,
      error,
      fullWidth,
      touched: t1,
      id,
      label,
      name,
      onBlur,
      onChange,
      required,
      placeholder,
      rows: t2,
      value,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = cornerAdornment;
    $[3] = description;
    $[4] = disabled;
    $[5] = error;
    $[6] = fullWidth;
    $[7] = id;
    $[8] = label;
    $[9] = name;
    $[10] = onBlur;
    $[11] = onChange;
    $[12] = placeholder;
    $[13] = props;
    $[14] = required;
    $[15] = t1;
    $[16] = t2;
    $[17] = value;
  } else {
    className = $[1];
    cornerAdornment = $[2];
    description = $[3];
    disabled = $[4];
    error = $[5];
    fullWidth = $[6];
    id = $[7];
    label = $[8];
    name = $[9];
    onBlur = $[10];
    onChange = $[11];
    placeholder = $[12];
    props = $[13];
    required = $[14];
    t1 = $[15];
    t2 = $[16];
    value = $[17];
  }
  const touched = t1 === undefined ? true : t1;
  const rows = t2 === undefined ? 3 : t2;
  const showError = error && touched;
  let t3;
  if ($[18] !== fullWidth) {
    t3 = classNames("block text-sm font-medium text-gray-700", {
      "w-full": fullWidth
    });
    $[18] = fullWidth;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const labelClassnames = t3;
  let t4;
  if ($[20] !== className || $[21] !== disabled || $[22] !== showError) {
    t4 = twMerge(classNames("appearance-none block w-full px-3 py-2 border rounded-md shadow-xs focus:outline-hidden sm:text-sm", {
      "pr-10 border-red-300 text-red-800 placeholder-red-300 focus:ring-red-400 focus:border-red-400": showError,
      "border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500": !showError,
      "opacity-50": disabled
    }, className));
    $[20] = className;
    $[21] = disabled;
    $[22] = showError;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  const inputClassnames = t4;
  let t5;
  if ($[24] !== label || $[25] !== required) {
    t5 = label && <div className="mb-1 flex justify-between"><div className="flex gap-x-1"><div className="mr-auto">{label}</div>{required && <div className="text-red-600">*</div>}</div></div>;
    $[24] = label;
    $[25] = required;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== cornerAdornment) {
    t6 = cornerAdornment && <div className="mb-1 flex justify-between"><div className="ml-auto">{cornerAdornment}</div></div>;
    $[27] = cornerAdornment;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== disabled || $[30] !== id || $[31] !== inputClassnames || $[32] !== name || $[33] !== onBlur || $[34] !== onChange || $[35] !== placeholder || $[36] !== props || $[37] !== ref || $[38] !== required || $[39] !== rows || $[40] !== value) {
    t7 = <textarea ref={ref} className={inputClassnames} disabled={disabled} id={id} name={name} onBlur={onBlur} onChange={onChange} required={required} placeholder={placeholder} defaultValue={value} rows={rows} {...props} data-gramm={false} data-enable-grammarly={false} />;
    $[29] = disabled;
    $[30] = id;
    $[31] = inputClassnames;
    $[32] = name;
    $[33] = onBlur;
    $[34] = onChange;
    $[35] = placeholder;
    $[36] = props;
    $[37] = ref;
    $[38] = required;
    $[39] = rows;
    $[40] = value;
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  let t8;
  if ($[42] !== showError) {
    t8 = showError && <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"><ExclamationCircleIcon className="h-5 w-5 text-red-600" aria-hidden="true" /></div>;
    $[42] = showError;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[44] !== t7 || $[45] !== t8) {
    t9 = <div className="relative">{t7}{t8}</div>;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] !== error || $[48] !== showError) {
    t10 = showError && <p className="mt-2 text-sm font-normal text-red-700">{error}</p>;
    $[47] = error;
    $[48] = showError;
    $[49] = t10;
  } else {
    t10 = $[49];
  }
  let t11;
  if ($[50] !== description) {
    t11 = description && <p className="mt-2 text-sm font-normal text-gray-500">{description}</p>;
    $[50] = description;
    $[51] = t11;
  } else {
    t11 = $[51];
  }
  let t12;
  if ($[52] !== id || $[53] !== labelClassnames || $[54] !== t10 || $[55] !== t11 || $[56] !== t5 || $[57] !== t6 || $[58] !== t9) {
    t12 = <label htmlFor={id} className={labelClassnames}>{t5}{t6}{t9}{t10}{t11}</label>;
    $[52] = id;
    $[53] = labelClassnames;
    $[54] = t10;
    $[55] = t11;
    $[56] = t5;
    $[57] = t6;
    $[58] = t9;
    $[59] = t12;
  } else {
    t12 = $[59];
  }
  return t12;
});
InputTextArea.displayName = 'InputTextArea';